<template>
  <section class="container d-flex flex-column mt-3">
    <header>
      <span class="h6">
        <router-link to="/">Início</router-link>
        / Lista de Efeitos
      </span>

      <h3 class="text-center my-5">Lista de Efeitos</h3>
    </header>

    <div
      v-for="effect in effects"
      :key="effect.id"
      class="d-flex flex-column flex-md-row mb-3"
    >
      <img :src="effect.img" :alt="effect.name" class="mr-md-3" />
      <div>
        <h4>
          <strong>{{ effect.name }}</strong>
        </h4>
        <p>{{ effect.desc }}</p>
      </div>
    </div>
  </section>
</template>

<script>
import effects from '../data/effects'

export default {
  name: 'effects',

  data: () => ({
    effects: effects.sort((a, b) =>
      a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    )
  })
}
</script>
